<template>
  <span v-if="this.params.data && getCountryId()" 
        :class="`flag-icon flag-icon-${getCountryId()}`" ></span>
  <!-- <span v-else :class="`flag-icon`" ></span> -->
</template>

<script>
export default {
  methods: {
    getCountryId() {
      if (_.isString(this.params.value)) 
        return this.params.value.toLowerCase();

      if (this.params.data.CountryId)
        return this.params.data.CountryId.toLowerCase();
    }
  }
}
</script>

<style lang="scss" scoped>
  .flag-icon {
    background-position: 0% 0%;
    background-size: cover;
    height: 1.0rem;
    width: calc(1.0rem * (640/480));
    display: block;
    margin: 0.75rem 0;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 8px 0px;
  }
</style>
